export default __webpack_public_path__ + "static/media/config-account.00229e3a.svg";